//store/modules/axios.js

import axios from 'axios'
const API_KEY = process.env.VUE_APP_API_KEY

const instance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': API_KEY,
  },
})

const excludedRoutes = ['/login', '/sign-up']

instance.interceptors.request.use(
  (config) => {
    if (excludedRoutes.some((route) => config.url.includes(route))) {
      return config
    }
    const token = localStorage.getItem('authToken')
    const tokenExpiry = localStorage.getItem('tokenExpiry')

    if (token && tokenExpiry) {
      if (Date.now() > tokenExpiry) {
        localStorage.removeItem('authToken')
        localStorage.removeItem('tokenExpiry')
        window.location.replace('/logout')
        config.headers.Authorization = `Bearer ''`
        return Promise.reject(new Error('Session expired'))
      } else {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // window.location.replace('/logout')
    return Promise.reject(error)
  },
)

export default instance
